// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1Zjgu","errorLogs":"EditorFooter_errorLogs__13vrp"};